
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g_451Uk2EGwauP_iGyyoHQh3Uzrf4HuQ71X0mHCvBFY_45WcMeta } from "/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexKj3kDncp4bjcs4mLPzWm3g0MobhED8DbCiBfPfYfDf4Meta } from "/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchc_45GVnVMIzlw0PENzF_45NGu8evGXjyEdCRHIdYJuuVKCgMeta } from "/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexbwcRNOkItmSAyxSMet6VmW_45RsX8DGt_214ZMOm1OZ40Meta } from "/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_937FWprBXgs8c6_1MAcbfQJDbWZvMmt3_FhbmcIA6GWAQMeta } from "/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexx2QoVIwYOegCWHUsacOtQQjpk4nqPotJXnAz6tdAATIMeta } from "/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93IwLZERUF5zfEBoQYFUJU6JldHxZPQMpmfYmyF40CGWsMeta } from "/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index59LU9uKovdad93MraGTFqwExaozBgLgO0qtVz1CBJKgMeta } from "/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_939PF4X5ggbE9RMCE2QTYgUwRhsC25n9APrcTYdM65lYYMeta } from "/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexvKCa_45OXGDB9cfdDeepXCmcYC9Lz2tk1wKIlMDsMvE2gMeta } from "/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index_De7Eqi0M90C5SFloDE4N4rhamJ7ZyX0ny7tNaOxgqMMeta } from "/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexx2QoVIwYOegCWHUsacOtQQjpk4nqPotJXnAz6tdAATIMeta || {},
    component: () => import("/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index59LU9uKovdad93MraGTFqwExaozBgLgO0qtVz1CBJKgMeta || {},
    component: () => import("/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexvKCa_45OXGDB9cfdDeepXCmcYC9Lz2tk1wKIlMDsMvE2gMeta || {},
    component: () => import("/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index_De7Eqi0M90C5SFloDE4N4rhamJ7ZyX0ny7tNaOxgqMMeta || {},
    component: () => import("/codebuild/output/src2895303015/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]